import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-home\"><path d=\"M8 2.5 12.8 8h-1.3v5H10v-3c0-1.1-.9-2-2-2s-2 .9-2 2v3H4.5V8H3.2zM8 1 1 9h2.5v5H7v-4c0-.6.5-1 1-1 .6 0 1 .4 1 1v4h3.5V9H15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol